import Beneficios from '../views/cliente/Beneficios.vue'
import Busqueda from '../views/cliente/Busqueda.vue'
import Comercio from '../views/cliente/comercio/Comercio.vue'
import Home from '../views/cliente/Home.vue'
import ReceptorClientes from '../views/cliente/ReceptorClientes.vue'
import LoginClienteAndComerciante from '../views/shared/login-cliente-and-comerciante/LoginClienteAndComerciante.vue'

export const Vistas = Object.freeze({
  Busqueda: {
    UrlRelativa: 'buscar',
  },
  /**Comercio específico, visto por usuarios */
  Comercio: {
    UrlRelativa: 'comercio',
  },
})

export const RouteNames = {
  home: 'cliente.home'
}

export const routes = [
  {
    path: '/dni/:dni',
    name: 'ReceptorClientes',
    component: ReceptorClientes,
  },
  {
    path: '/',
    component: LoginClienteAndComerciante,
    name: 'InicioLogin'
  },
  {
    path: '/home',
    component: Home,        
    children: [
      {
        component: Beneficios,
        name: RouteNames.home,
        path: '',
      },{
        component: Busqueda,
        name: 'Busqueda',
        path: Vistas.Busqueda.UrlRelativa + '/:busqueda',
      },
      {
        component: Comercio,
        name: 'Comercio',
        path: Vistas.Comercio.UrlRelativa + '/:id',
      },
    ]
  }
]
